import { useEffect, useRef, useState } from 'react';
import { getPrevSessionThreadId, getDocRef, setSnapshotListener } from './firebase';

export default function useThreadData({ uid }) {
    const [threadData, setThreadData] = useState(null);
    const [threadLoading, setThreadLoading] = useState(true);
    const [threadError, setThreadError] = useState(null);
    const docRef = useRef(null);

    useEffect(() => {
        try {
            const threadId = getPrevSessionThreadId();
            if (!threadId) {   
                setThreadLoading(false);
                return;
            }
            const documentRef = getDocRef(uid);
            docRef.current = documentRef;
        } catch (error) {
            setThreadError(error);
        }
    }, []);

    useEffect(() => {
        if (!docRef.current) {
            setThreadLoading(false);
            return;
        }
        console.log("THREAD LISTEN");
        setSnapshotListener(docRef, setThreadData, setThreadLoading);
    }, [docRef.current]);

    return [threadData, threadLoading, threadError, docRef];
};